module.exports = __webpack_public_path__ + "img/ECGADAPTER.efc23b72.jpg";